import styled from '../../styles/styled';
import { focus } from '../../styles/theme';
import { Box } from '../layout';
export const FocusWithinContainer = styled(Box)({
    width: '100%',
    ':focus-within': focus.shadow,
});
//# sourceMappingURL=focus_within_container.js.map